import React, {Component} from 'react';
import './App.css';
import {connect} from 'react-redux';
import Header from './components/header/Header';
import Content from './components/content/Content';
import Test from './components/Test';
import Footer from './components/footer/Footer';
import {
    BrowserRouter as Router,
    Route
} from 'react-router-dom';
import {bindActionCreators} from "redux";
import {closeNavigation, setApproved, setCurrentElement, setDomainName, openNavBar, closeNavBar} from "./actions";
import Modal from "./UI/Modal/Modal";
import ConnectionStatus from "./components/ConnectionStatus";
import {
    createMuiTheme,
    Theme,
    ThemeProvider
} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button';



const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#283593',
            contrastText: '#fff',
        },
        secondary: {
            main: '#0288d1',
            contrastText: '#fff',
        }
    },
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            buttonClosed:false
        }
    }

    componentWillMount() {
        this.props.setApproved(window.location.href.includes('course_approve'));
    }

    componentDidUpdate(prevProps) {
    }

    render() {

        return (
            <Router>
                <div id="app-wrap">
                    <Route exact path="/viewer/get_test/:test_id" component={Test}/>
                    <ThemeProvider theme={theme}>
                    <div id="app-main"
                         onClick={this.props.closeNavigation}
                    >
                        {this.renderModal()}
                        {this.renderHeader()}
                        <ConnectionStatus/>
                        <Route exact path="/viewer/course/:course_pk" component={Content}/>
                        <Route exact path="/viewer/course_approve/:course_pk" component={Content}/>
                        <Route exact path="/viewer/course/:course_pk/nodes/:node_id" component={Content}/>
                        <Route exact path="/viewer/course_approve/:course_pk/nodes/:node_id" component={Content}/>
                        <Route exact path="/viewer/course/:course_pk/nodes/:node_id/item/:item_id" component={Content}/>
                        <Route exact path="/viewer/course_approve/:course_pk/nodes/:node_id/item/:item_id"
                               component={Content}/>
                     {this.renderFooter()}
                    </div>
                    </ThemeProvider>
                </div>
         
            </Router>

        );
    }

    onHelpClicked = () => {
        this.setState({showModal: true});
    };

    onMenuClicked = () => {
    
        this.props.openNavBar(this.props.buttonClosed);
    };


    renderHeader = () => {
        if (window.location.href.includes('get_test')) {
            return null;
        }

        let courseName = '';
        if (this.props.chapters.chaptersList.length !== 0) {
            courseName = this.props.chapters.chaptersList[0]["text"];
        }

        return (<Header
            setCurrentItem={(element) => this.props.previous(element.nodeId, element.item_id, this.props.allElements, this.props.chapterContent, element.courseId)}
            locate={this.props.navigation}
            title={ courseName }
            onModalClick={this.onHelpClicked}
            onMenuClick = {this.onMenuClicked}
        />)
    };

    renderFooter = () => {
        if (window.location.href.includes('get_test')) {
            return null
        }

        return (<Footer/>);
    };

    renderModal = () => {
        if (this.state.showModal) {
            return (
                <Modal
                    link={"https://www.youtube.com/embed/udVYcZxtoUI"}
                    onCloseModal={this.onCloseModal}
                />
            )
        }

    };

    onCloseModal = () => {
        this.setState({showModal: false})
    };


}

const mapStateToProps = state => ({
    chapters: state.chapters,
    navigation: state.navigation,
    allElements: state.allElements,
    chapterContent: state.chapterContent,
    domainName: state.domainReducer,
    connection: state.connection,
    buttonClosed: state.buttonClosed

});

function dispatchToProps(dispatch) {
    return bindActionCreators({
        previous: setCurrentElement,
        setDomainName: setDomainName,
        closeNavigation: closeNavigation,
        openNavBar: openNavBar,
        closeNavBar:closeNavBar,
        setApproved: setApproved
    }, dispatch);
}

export default connect(mapStateToProps, dispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js